module.exports = __webpack_public_path__ + "static/media/3.976c0d1f.JPG";